import React, { useCallback, useEffect, useState } from 'react';
import { ELEMENT_LINK } from '@udecode/slate-plugins';
import { useEditor } from 'slate-react';
import PropTypes from 'prop-types';
import { StyledTextButton, StyledPopup } from './styles';
import LinkForm from './LinkForm';
import { ESC } from '../../../constants/keycodes';

const LinkToolBar = React.memo(({ typeLink }) => {
  const editor = useEditor();
  const [isOpen, setIsOpen] = useState(false);
  const [selection, setSelection] = useState(null);

  const toggleIsOpen = useCallback(() => {
    setIsOpen(prevIsOpen => {
      if (!prevIsOpen) {
        setSelection(editor.selection);
      }
      return !prevIsOpen;
    });
  });

  const handleClick = event => {
    event.stopPropagation();
    event.preventDefault();

    toggleIsOpen();
  };

  const handleKeyDown = event => {
    if (isOpen && event.keyCode === ESC) {
      toggleIsOpen();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [isOpen]);

  const handleLink = useCallback(
    ({ url }) => {
      editor.selection = selection;
      editor.upsertLinkAtSelection(editor, url, { typeLink });
    },
    [selection, editor]
  );

  return (
    <>
      <StyledTextButton type="button" onClick={handleClick}>
        + Ссылка
      </StyledTextButton>
      <StyledPopup isOpen={isOpen}>
        {isOpen && <LinkForm onSubmit={handleLink} onClose={toggleIsOpen} />}
      </StyledPopup>
    </>
  );
});

LinkToolBar.propTypes = {
  typeLink: PropTypes.string,
};

LinkToolBar.defaultProps = {
  typeLink: ELEMENT_LINK,
};

export default LinkToolBar;
